import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=0b06f19a&scoped=true"
import script from "./VideoPlayer.vue?vue&type=script&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&lang=js"
import style0 from "../../../node_modules/video.js/dist/video-js.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./VideoPlayer.vue?vue&type=style&index=1&id=0b06f19a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b06f19a",
  null
  
)

export default component.exports